import { ActionReducerMapBuilder, current, PayloadAction } from '@reduxjs/toolkit';
import { STATUS } from '../../utils/status';
import { UploadState } from '../interfaces/interface';
import { createAllocation, createBulkAllocation, createBulkUnallocation, createBulkUnallocationType1, createMetaQC, createUpload, getCompanyTaskList, getCompletedTask, getUnallocatedTaskCount, getUpload, getUploadTaskPage, updateCompletedTask, updateUpload } from '../slices/upload';

const ExtraReducers = (builder: ActionReducerMapBuilder<UploadState>) => {
  builder
    .addCase(createUpload.pending, (state) => {
      state.createStatus = STATUS.PENDING;
      state.createUploadMessage = null
    })
    .addCase(createUpload.fulfilled, (state, action: PayloadAction<any>) => {
      state.upload = action.payload;
      state.createStatus = STATUS.SUCESS;
      state.createUploadMessage = action.payload?.message || "Success"
    })
    .addCase(createUpload.rejected, (state, action: any) => {
      state.createStatus = STATUS.FAILED;
      console.log({ action })
      state.createUploadMessage = action.payload?.message || "An error occurred"
    })
    .addCase(createAllocation.pending, (state) => {
      state.createAllocationStatus = STATUS.PENDING;
      state.createAllocationMessage = null
    })
    .addCase(createAllocation.fulfilled, (state, action: PayloadAction<any>) => {

      state.createAllocationFailedMessage = action.payload?.data?.data?.allocations?.failed_allocations?.length
        ? action.payload?.data?.data?.allocations?.failed_allocations[0].reason
        : '';

      if (state.createAllocationFailedMessage) {
        return;
      }

      if (Object.keys(action.payload).includes('payload')) {
        console.log({ action: action.payload })
        if (Object.keys(action.payload.payload.payload).includes('task_ids')) {
          action.payload.payload.payload.task_ids.map((task_id: any) => {
            const taskIndex = state.upload.results.findIndex((task: any) => task.id === task_id)
            if (action.payload.payload.payload.action === 'assign') {
              if (action.payload.payload.payload.type === "REVIEW") {
                state.upload.results[taskIndex] = {
                  ...state.upload.results[taskIndex],
                  review_allocations: [
                    ...state.upload.results[taskIndex].review_allocations,
                    {
                      email: action.payload?.payload?.extraData?.expertDetails?.[0],
                      status: 'NOT STARTED',
                      meta_qc_status: 'NOT STARTED',
                      id: action.payload?.payload?.extraData?.expertDetails?.[1]
                      // id: action.payload?.data?.allocations?.successful_allocations_list[0]
                    }
                  ]
                }
              }
              else {
                state.upload.results[taskIndex] = {
                  ...state.upload.results[taskIndex],
                  task_allocations: [
                    ...state.upload.results[taskIndex].task_allocations,
                    {
                      email: action.payload?.payload?.extraData?.expertDetails?.[0],
                      id: action.payload?.payload?.extraData?.expertDetails?.[1],
                      status: 'NOT STARTED',
                      meta_qc_status: 'NOT STARTED'
                      //id: action.payload?.data?.allocations?.successful_allocations_list[0]
                    }
                  ]
                }
              }
            } else if (action.payload.payload.payload.action === 'unassign') {
              if (action.payload.payload.payload.type === "REVIEW") {
                state.upload.results[taskIndex] = {
                  ...state.upload.results[taskIndex],
                  review_allocations: []
                }
              }
              else {
                state.upload.results[taskIndex] = {
                  ...state.upload.results[taskIndex],
                  task_allocations: []
                }
              }
            }
            return task_id;
          })
        }
      }
      // state.upload = action.payload; 
      state.createAllocationStatus = STATUS.SUCESS;
      state.createAllocationMessage = action.payload?.data?.message || "Success"
    })
    .addCase(createAllocation.rejected, (state, action: any) => {
      state.createAllocationStatus = STATUS.FAILED;
      state.createAllocationMessage = action.payload?.data?.message || "An error occurred"
    })
    .addCase(createBulkAllocation.pending, (state) => {
      state.createBulkAllocationStatus = STATUS.PENDING;
      state.createBulkAllocationMessage = ""
    })
    .addCase(createBulkAllocation.fulfilled, (state, action: PayloadAction<any>) => {
      state.upload = action.payload;
      state.createBulkAllocationStatus = STATUS.SUCESS;
      console.log(action.payload?.message)
      state.createBulkAllocationMessage = action.payload?.data?.message || "Success"
    })
    .addCase(createBulkAllocation.rejected, (state, action: PayloadAction<any>) => {
      state.createBulkAllocationMessage = action.payload?.message || "An error occurred"
      state.createBulkAllocationStatus = STATUS.FAILED;
    })
    .addCase(createBulkUnallocation.pending, (state) => {
      state.createBulkUnallocationStatus = STATUS.PENDING;
      state.createBulkUnallocationMessage = null
    })
    .addCase(createBulkUnallocation.fulfilled, (state, action: PayloadAction<any>) => {
      state.upload = action.payload;
      state.createBulkUnallocationStatus = STATUS.SUCESS;
      state.createBulkUnallocationMessage = action.payload.data?.message || "Success"
    })
    .addCase(createBulkUnallocation.rejected, (state, action: any) => {
      state.createBulkUnallocationStatus = STATUS.FAILED;
      state.createBulkUnallocationMessage = action.payload?.message || "An error occrred"
    })

    .addCase(createBulkUnallocationType1.pending, (state) => {
      state.createBulkUnallocationType1Status = STATUS.PENDING;
      state.createBulkUnallocationType1Message = null
    })
    .addCase(createBulkUnallocationType1.fulfilled, (state, action: PayloadAction<any>) => {
      state.upload = action.payload;
      state.createBulkUnallocationType1Status = STATUS.SUCESS;
      state.createBulkUnallocationType1Message = action.payload.data?.message || "Success"
    })
    .addCase(createBulkUnallocationType1.rejected, (state, action: any) => {
      state.createBulkUnallocationType1Status = STATUS.FAILED;
      state.createBulkUnallocationType1Message = action.payload?.message || "An error occrred"
    })

    .addCase(getUpload.pending, (state) => {
      state.getStatus = STATUS.PENDING;
      state.getUploadMessage = null
    })
    .addCase(getUpload.fulfilled, (state, action: PayloadAction<any>) => {
      state.upload = action.payload;
      state.getStatus = STATUS.SUCESS;
      state.getUploadMessage = action.payload?.message || "Success"
    })
    .addCase(getUpload.rejected, (state, action: any) => {
      state.getStatus = STATUS.FAILED;
      state.getUploadMessage = action.payload?.message || "An error occurred"
    })

    .addCase(getUploadTaskPage.pending, (state) => {
      state.getUploadTaskStatus = STATUS.PENDING;
      state.getUploadTaskMessage = null
    })
    .addCase(getUploadTaskPage.fulfilled, (state, action: PayloadAction<any>) => {
      state.uploadTask = action.payload;
      state.getUploadTaskStatus = STATUS.SUCESS;
      state.getUploadTaskMessage = action.payload?.message || "Success"
    })
    .addCase(getUploadTaskPage.rejected, (state, action: any) => {
      state.getUploadTaskStatus = STATUS.FAILED;
      state.getUploadTaskMessage = action.payload?.message || "An error occurred"
    })
    .addCase(getUnallocatedTaskCount.pending, (state) => {
      state.getTaskCountStatus = STATUS.PENDING;
      state.getUnallocatedTaskCountMessage = null
    })
    .addCase(getUnallocatedTaskCount.fulfilled, (state, action: PayloadAction<any>) => {
      state.unallocatedCount = action.payload.count;
      state.getTaskCountStatus = STATUS.SUCESS;
      state.getUnallocatedTaskCountMessage = action.payload?.message || "Success"
    })
    .addCase(getUnallocatedTaskCount.rejected, (state, action: any) => {
      state.getTaskCountStatus = STATUS.FAILED;
      state.getUnallocatedTaskCountMessage = action.payload?.message || "An error occurred"
    })
    .addCase(updateUpload.pending, (state) => {
      state.updateStatus = STATUS.PENDING;
      state.updateUploadMessage = null
    })
    .addCase(updateUpload.fulfilled, (state, action: PayloadAction<any>) => {
      const updateUpload = action.payload;
      state.upload.results = state.upload.results.map((upload: any) =>
        upload.id === updateUpload.id ? updateUpload : upload
      );
      state.updateStatus = STATUS.SUCESS;
      state.updateUploadMessage = action.payload?.message || "Success"
    })
    .addCase(updateUpload.rejected, (state, action: any) => {
      state.updateStatus = STATUS.FAILED;
      state.updateUploadMessage = action.payload?.message || "An error occurred"
    })
    .addCase(createMetaQC.pending, (state) => {
      state.createMetaQCStatus = STATUS.PENDING;
      state.createMetaQCMessage = null
    })
    .addCase(createMetaQC.fulfilled, (state, action: any) => {
      const currentIndex = state.upload.results.findIndex(el => action.payload.payload.allocation_ids.includes(el.task_allocations[0]?.alloc_id) || action.payload.payload.allocation_ids.includes(el.review_allocations[0]?.alloc_id))

      state.upload.results[currentIndex] = {
        ...state.upload.results[currentIndex],
        ...(state.upload.results[currentIndex].review_allocations.length > 0 && {
          review_allocations: [{
            ...state.upload.results[currentIndex].review_allocations[0],
            meta_qc_status: action.payload.payload.status
          }]
        }),
        ...(state.upload.results[currentIndex].task_allocations.length > 0 && {
          task_allocations: [{
            ...state.upload.results[currentIndex].task_allocations[0],
            meta_qc_status: action.payload.payload.status
          }]
        })
      }

      state.taskCompleted.data.results = state.taskCompleted.data.results.map((el: any) => {
        if (el.tasks.length > 0) {
          return {
            ...el,
            tasks: el.tasks.map((task: any) => {
              if (action.payload.payload.allocation_ids.includes(task.task_allocation_id)) {
                return {
                  ...task,
                  meta_qc_status: "READY FOR DELIVERY"
                }
              } else {
                return task
              }
            })
          }
        } else {
          return el
        }
      })

      state.metaqc = action.payload.data;
      state.createMetaQCStatus = STATUS.SUCESS;
      state.createMetaQCMessage = action.payload?.message || "Success"
    })
    .addCase(createMetaQC.rejected, (state, action: any) => {
      state.createMetaQCStatus = STATUS.FAILED;
      state.createMetaQCMessage = action.payload?.message || "An error occurred"
    })
    .addCase(getCompletedTask.pending, (state) => {
      state.getStatus = STATUS.PENDING;
      state.getCompletedTaskMessage = null
    })
    .addCase(getCompletedTask.fulfilled, (state, action) => {
      state.getStatus = STATUS.SUCESS;
      state.taskCompleted = action.payload;
      state.getCompletedTaskMessage = null
    })
    .addCase(getCompletedTask.rejected, (state, action: any) => {
      state.getStatus = STATUS.FAILED;
      state.getCompletedTaskMessage = action.payload?.message || "An error occurred"
    })
    .addCase(updateCompletedTask.pending, (state) => {
      state.updateCompletedTaskStatus = STATUS.PENDING;
      state.updateCompletedTaskMessage = null
    })
    .addCase(updateCompletedTask.fulfilled, (state, action) => {
      state.updateCompletedTaskStatus = STATUS.SUCESS;
      const action_id = action.payload.payload.action_id
      const response_id = action.payload.payload.response_id
      const data = action.payload.data.data
      let currentResponseIndex = state.taskCompleted.data.results.findIndex((result: any) => result.tasks[0].responses[0].id === response_id)
      let currentTask = state.taskCompleted.data.results[currentResponseIndex].tasks[0].responses[0].actions.find((action: any) => action.id === action_id)
      let currentTaskIndex = state.taskCompleted.data.results[currentResponseIndex].tasks[0].responses[0].actions.findIndex((action: any) => action.id === action_id)
      currentTask = {
        ...currentTask,
        id: data.id,
        action_value: currentTask.action_value.map((av: any) => {
          return {
            ...av,
            ...data.action_value
          }
        })
      }
      state.taskCompleted.data.results[currentResponseIndex].tasks[0].responses[0].actions[currentTaskIndex] = currentTask
      // state.taskCompleted = action.payload;
      state.updateCompletedTaskMessage = action.payload.data.message
    })
    .addCase(updateCompletedTask.rejected, (state, action: any) => {
      state.updateCompletedTaskStatus = STATUS.FAILED;
      state.updateCompletedTaskMessage = action.payload?.message || "An error occurred"
    })

    .addCase(getCompanyTaskList.pending, (state) => {
      state.getStatus = STATUS.PENDING;
      state.getUploadMessage = null;
    })
    .addCase(getCompanyTaskList.fulfilled, (state, action: PayloadAction<any>) => {
      state.upload = action.payload;
      state.getStatus = STATUS.SUCESS;
      state.getUploadMessage = action.payload?.message || "Success";
    })
    .addCase(getCompanyTaskList.rejected, (state, action: any) => {
      state.getStatus = STATUS.FAILED;
      state.getUploadMessage = action.payload?.message || "An error occurred";
    });

};

export default ExtraReducers;
